import api from '../axios'
import Vue from 'vue'
import router from '../router/index'
import * as types from './types'

export default {
	UserLogin({ commit }, {token,userId,email}) {
		commit(types.LOGIN, token)
		commit(types.USERID, userId)
		commit(types.USERNAME, email)
	},

	UserLogout({ commit }) {
		commit(types.LOGOUT)
	},


}



// WEBPACK FOOTER //
// ./src/store/actions.js